import formatDistance from'./_lib/formatDistance/index.js';import formatLong from'./_lib/formatLong/index.js';import formatRelative from'./_lib/formatRelative/index.js';import localize from'./_lib/localize/index.js';import match from'./_lib/match/index.js';/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */var locale={code:'en-US',formatDistance:formatDistance,formatLong:formatLong,formatRelative:formatRelative,localize:localize,match:match,options:{weekStartsOn:0/* Sunday */,firstWeekContainsDate:1}};export default locale;